/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
import http from '@/services/http-common';

/* export const IPlistt = (Data: BodyInit) => {
  fetch('https://api.proxyscrape.com/v2/online_check.php', {
    method: 'post',

    body: Data,
  }).then((response) => {
    // console.log(response, 'response');
    response.json().then((data) => {
      console.log('res', data);
    });
  });
}; */

class PcheckerService {
  IPlist(Data: BodyInit): Promise<any> {
    return http.post('https://api.proxyscrape.com/v2/online_check.php', Data);
  }
}
export default new PcheckerService();
